import { SvgIconModule } from '@core/modules/svgIcons.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule as XtButtonModule } from '@xt/ui-kit';

@NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, SvgIconModule, TranslocoModule, XtButtonModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
